import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { OFFER_TYPE_HOTEL } from '~/consts/offerTypes';

import OffersService from '~/services/OffersService';

import { offerQueryKeys } from './useGetOffer';

// Off-sale hotels are filtered out after the search, so it fetches more than it shows.
const RESULT_LIMIT = 50;

/** Callers debounce, so each settled term is its own cache entry. */
export function useSearchFlashOffers(search: string) {
  return useQuery({
    queryKey: [...offerQueryKeys.all, 'flash-search', search] as const,
    queryFn: async (): Promise<Array<App.Offer>> => {
      const response = await OffersService.getOffers({
        page: 1,
        limit: RESULT_LIMIT,
        type: OFFER_TYPE_HOTEL,
        queryString: search || undefined,
        region: 'any',
      });
      return response?.result ?? [];
    },
    placeholderData: keepPreviousData,
  });
}
